import React, { useEffect, useState } from "react";
import { useStateValue } from "../../Hooks/stateProvider";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { TextField } from "@mui/material";
import Styles from "./Styles/moduleLayout.module.css";
import uploadLogo from "../../images/CtrUpload.svg"
const UploadAction = (props) => {
  const [{ fileName }, dispatch] = useStateValue();
  const [file, setFile] = useState("");
  const [Details, setDetails] = useState();
  const handleFile = () => {
    setFile("")
    setDetails();
  }
  useEffect(() => {
    dispatch({ type: "fileName", fileName:file })
    dispatch({ type: "fileDetails", fileDetails:Details })
  }, [file, Details])


 


  return (
    <>
      <input
        type="file"
        id="uploadFile"
        // required
        style={{ display: "none" }}
        onClick={event => event.target.value = null}
        onChange={(event) => {
          setDetails(event?.target?.files[0]);
          setFile(event?.target?.files[0]?.name);
        }}
      />
      <div id="uploadFileDelete"
        style={{ cursor: "pointer", display: "flex", alignItems: "flex-end" }}
      >
        <div>
          {fileName ? (
            <TextField
              id="outlined-basic"
              value={fileName}
              style={{ width: fileName === "" ? "0px" : "13rem" }}
              variant="standard"
              inputProps={{
                style: {
                  textAlign: "center",
                },
              }}
            />
          ) : (
            ""
          )}
        </div>
        <div
        >
          {fileName && <DeleteForeverIcon sx={{ color: "#e6435b" }} onClick={handleFile} />}

        </div>
      </div>

      { props.type!=undefined ? (fileName == "" && <img src={uploadLogo} alt="Upload Logo" style={{width:"600",height:"80",cursor:"pointer"}} onClick={() => {
           // setFileName("");
          document.getElementById("uploadFile").click();

        }} />):(fileName == "" && <button
          className={Styles.BrowseBtn}
          onClick={() => {
            // setFileName("");
            document.getElementById("uploadFile").click();
  
          }}
          // required
        >
          UPLOAD
        </button>)} 
      
    </>
  )
}

export default UploadAction;